import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';

const ChatArea = ({ messages }) => {
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  //const scrollToBottom = () => {
    //messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  //};


  //useEffect(() => {
    //scrollToBottom();
  //}, [messages]);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);


  return (
    <div className="h-[500px] overflow-y-auto p-6" ref={chatContainerRef}>
      {messages.map((message, index) => (
        <ChatMessage key={index} message={message} index={index} />
      ))}
    </div>
  );
};

export default ChatArea;